import { render, staticRenderFns } from "./CourseChildren.vue?vue&type=template&id=dc204090&scoped=true"
import script from "./CourseChildren.vue?vue&type=script&lang=js"
export * from "./CourseChildren.vue?vue&type=script&lang=js"
import style0 from "./CourseChildren.vue?vue&type=style&index=0&id=dc204090&prod&scoped=true&lang=css"
import style1 from "./CourseChildren.vue?vue&type=style&index=1&id=dc204090&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc204090",
  null
  
)

export default component.exports